/**
 * for the scroll nudge to work, a nudge needs to be added through
 * the pagebuilder. The nudge needs to have a wrapper with class 'nudge-wrapper' and the nudge 
 * itself has class 'nudge'
 * 
 * also, a target (where the scroll leads) needs to have the class 'scroll-nudge-target'
 */

export default class scrollNudge {
    constructor() {
        this.initScrollNudge();
    }

    initScrollNudge() {
        const scrollNudge = document.querySelector('.nudge-wrapper .nudge');
        const scrollTarget = document.querySelector('.scroll-nudge-target');

        if (scrollNudge) {
            scrollNudge.addEventListener("click", () => {
                window.scroll({left: 0, top: scrollTarget.offsetTop - 88, behavior: "smooth"});
            });
        }
    }
}